import { Table } from "@/features/Table";
import { type A7OPCVMUnderlyingTS, getUnderlyingsTsColumns } from "./columns";
import {
  FilterA7OPCVMUnderlyingTS,
  FilterA7OPCVMUnderlyingTSSchema,
} from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_underlying_ts";

export const A7OPCVMUnderlyingTSTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getUnderlyingsTsColumns(t), [t, i18n.language]);

  return (
    <Table<A7OPCVMUnderlyingTS, FilterA7OPCVMUnderlyingTSSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Underlying time series",
      })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMUnderlyingTS table_name={table_name} />}
      client="a7"
      disable_translations_request={true}
    />
  );
};
